import { useEffect, useState } from 'react';
import { callApi } from 'src/utils/apiCall';

export default function useStaffDiaryAccess(practiceId, userId) {
  const [result, setResult] = useState(null);
  const key = `${userId}:${practiceId}`;
  useEffect(() => {
    let active = true;
    setResult(null);
    if (!practiceId || !userId) return undefined;
    const day = new Date().toISOString().slice(0, 10);
    callApi(`/api/v1/practices/${practiceId}/pms/my-diary/?start=${day}&end=${day}`, 'GET', null, false, {
      suppressServerErrorDispatch: true,
    })
      .then((response) => {
        if (active && response?.ok) setResult({ key, access: response.data?.access });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [key, practiceId, userId]);
  return result?.key === key ? result.access : null;
}
